import { render, staticRenderFns } from "./ModuleSection.vue?vue&type=template&id=0bf8b986&scoped=true"
import script from "./ModuleSection.vue?vue&type=script&lang=js"
export * from "./ModuleSection.vue?vue&type=script&lang=js"
import style0 from "./ModuleSection.vue?vue&type=style&index=0&id=0bf8b986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf8b986",
  null
  
)

export default component.exports